module.exports = __webpack_public_path__ + "static/media/dial_legend_consumption_exceeded.b43998bc.svg";